import { useEffect } from "react";
import CustomModalAlert from "../../../components/CustomModalAlert";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import { useCreateBlMutation } from "../../../services/bl-export/BLExportService";
import NewBlFormRF from "../forms/NewBlFormRF";

interface props {
  isOpen: boolean;
  onClose: () => void;
  callback: () => void;
}

const ModalNewBl = ({ isOpen, onClose, callback }: props) => {
  const [createBlMutation, { isSuccess, isError, reset }] =
    useCreateBlMutation();

  const handleCloseSuccess = () => {
    onClose();
    setTimeout(reset, 200);
  };

  useEffect(() => {
    if (isSuccess === true) {
      callback();
      return;
    }
  }, [isSuccess, callback]);

  if (isError === true) {
    return (
      <CustomModalAlert
        onClose={handleCloseSuccess}
        show={isError}
        type="error"
        message="No se pudo crear el BL. Intente luego"
      />
    );
  }

  if (isSuccess === true) {
    return (
      <CustomModalAlert
        onClose={handleCloseSuccess}
        show={isSuccess}
        type="success"
        message="El BL se ha creado correctamente"
      />
    );
  }

  return (
    <div>
      <CustomDialog
        maxWidth="md"
        title="Crear Nuevo BL"
        isOpen={isOpen}
        handleClose={onClose}
        hideActionButtons
      >
        <NewBlFormRF
          submitAction={(values) => {
            createBlMutation(values);
          }}
        />
      </CustomDialog>
    </div>
  );
};

export default ModalNewBl;
